import axios from 'axios';

/** Avoid /api/api when REACT_APP_BACKEND_URL already ends with /api (common in DO deploy). */
export function getBackendOrigin() {
  const raw = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').trim().replace(/\/+$/, '');
  return raw.endsWith('/api') ? raw.slice(0, -4) : raw;
}

const api = axios.create({
  baseURL: `${getBackendOrigin()}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' · ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export default api;
